export enum DateObjectKinds {
  Normal = 0,
  HisItem = 1,
  UserDefined = 2,
}
